import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonLoaderLegacyComponent } from '@mkp/shared/ui-library';

@Component({
  selector: 'mkp-product-table-column-skeleton',
  templateUrl: './product-table-column-skeleton.component.html',
  styleUrl: './product-table-column-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SkeletonLoaderLegacyComponent],
})
export class ProductTableColumnSkeletonComponent {}
